var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSnsLinked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2716 25H24.9984L25 18.4043C25 15.1664 24.3035 12.6775 20.5262 12.6775C19.8175 12.6511 19.1149 12.8178 18.4932 13.1598C17.8716 13.5018 17.3542 14.0063 16.9962 14.6196H16.9461V12.9765H13.3683V24.9996H17.0952V19.0519C17.0952 17.4834 17.3921 15.9644 19.3332 15.9644C21.2467 15.9644 21.2716 17.7592 21.2716 19.1534V25Z",
    fill: "#CDD6E3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.96151 10.9682C8.31722 11.2062 8.73539 11.3331 9.16314 11.3331C9.44715 11.333 9.72838 11.2769 9.99076 11.168C10.2531 11.0591 10.4915 10.8994 10.6923 10.6982C10.8931 10.497 11.0524 10.2581 11.161 9.99527C11.2697 9.7324 11.3255 9.45066 11.3255 9.16615C11.3254 8.73765 11.1985 8.31879 10.9608 7.96255C10.7231 7.60631 10.3853 7.32868 9.99004 7.16477C9.59482 7.00086 9.15995 6.95803 8.74044 7.04171C8.32092 7.12538 7.93559 7.33179 7.63318 7.63484C7.33077 7.93789 7.12486 8.32396 7.04148 8.74425C6.95811 9.16453 7.00101 9.60014 7.16478 9.99599C7.32854 10.3918 7.60581 10.7302 7.96151 10.9682Z",
    fill: "#CDD6E3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.29582 25H11.0266V12.9765H7.29582V25Z",
    fill: "#CDD6E3"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnsLinked);
export default __webpack_public_path__ + "static/media/sns_linked.9bd83534183eb2a92df4f231a040bae3.svg";
export { ForwardRef as ReactComponent };